class CartNotification extends HTMLElement {
    constructor() {
        super();

        this.notification = document.getElementById('cart-notification');
        this.header = document.querySelector('sticky-header');
        this.stickyAddToCart = document.getElementById('stickyAddToCart');
        this.onBodyClick = this.handleBodyClick.bind(this);
        this.isOpen = false;
        this.lastScrollTop = 0;
        this.isClosing = false;
        this.isBodyScrollLocked = false;
        this.lockedBodyStyles = null;
        this.lockedScrollY = 0;
        this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.parentSection = document.querySelectorAll('product-recommendations');
        if(this.getAttribute('data-free-shipping-threshold') !== null){
            this.freeShippingThreshold = this.getAttribute('data-free-shipping-threshold');
            this.freeShippingText = this.querySelector('.free-shipping-hidden') || "";
            this.notFreeShippingText = this.querySelector('.not-free-shipping') || "";
            this.cartTotal = 0;
        }
        this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
            closeButton.addEventListener('click', this.close.bind(this))
        );

        this.chatIcon = document.getElementById('genesys-mxg-frame') || this.setupMutationObserver();

        subscribe(PUB_SUB_EVENTS.addToCart, async (payload) => {
            if (document.getElementById('rea-minicart')) return;

            this.setQuantity(payload.productVariantQuantity);
            if(payload.productVariantQuantity == null && payload.cartData.quantity != 0){
                this.setQuantity(payload.cartData.quantity, payload.cartData.final_price, payload.cartData.original_price);
            }
            if(this.getAttribute('data-free-shipping-threshold') !== null){
                this.setFreeShipping(this.getAttribute('data-free-shipping-threshold'));
            }
            //this.adjustCartNotificationPosition();
            this.open();
        });

        this.handleViewportChange = this.handleViewportChange.bind(this);
        window.addEventListener('scroll', this.handleScroll.bind(this));
        window.addEventListener('resize', this.handleViewportChange);
        window.addEventListener('orientationchange', this.handleViewportChange);
        this.updateMobileTopOffset();
        this.updateDesktopScrollbarWidth();
    }

    getScrollbarWidth() {
        const measurement = document.createElement('div');
        measurement.style.width = '100px';
        measurement.style.height = '100px';
        measurement.style.overflow = 'scroll';
        measurement.style.position = 'absolute';
        measurement.style.top = '-9999px';
        measurement.style.left = '-9999px';
        document.body.appendChild(measurement);
        const scrollbarWidth = measurement.offsetWidth - measurement.clientWidth;
        document.body.removeChild(measurement);
        return scrollbarWidth;
    }

    updateDesktopScrollbarWidth() {
        const measuredScrollbarWidth = this.getScrollbarWidth();
        const scrollbarWidth =
            window.innerWidth > 767
                ? (measuredScrollbarWidth > 0 ? measuredScrollbarWidth : 17)
                : 0;
        document.documentElement.style.setProperty('--cart-scrollbar-width', `${scrollbarWidth}px`);
    }

    async setFreeShipping(freeShippingThreshold) {
        try {
            const response = await fetch('/cart.js');
            const data = await response.json();
            this.cartTotal = data.total_price;
            if(freeShippingThreshold){
                if( this.cartTotal >= freeShippingThreshold ){
                    if(this.freeShippingText != '') {
                        this.freeShippingText.classList.remove('tw-hidden');
                        this.notFreeShippingText.classList.add('tw-hidden');
                    }
                } else {
                    this.notFreeShippingText.setAttribute('data-cart-amount', this.cartTotal);
                    this.querySelector('.cart-amount').innerHTML = (freeShippingThreshold - this.cartTotal) / 100;
                    this.querySelector('.progress-percentage').style.width = (this.cartTotal / freeShippingThreshold) * 100 + '%';
                    this.querySelector('.progress-percentage').innerHTML = parseInt((this.cartTotal / freeShippingThreshold) * 100) + '%';
                }
            } else {
                return;
            }
        } catch (error) {
            console.error("Errore nel recupero del carrello:", error);
        }
    }

    setQuantity(quantity, relatedPrice, relatedOriginalPrice) {
        const quantityNotification = this.querySelector('#quantity-notification');
        const totalPriceElement = this.querySelector('#total-price');
        const originalTotalPriceElement = this.querySelector('#original-total-price');
        const promoTotalPriceElement = this.querySelector('#promo-total-price');
        const promoOriginalTotalPriceElement = this.querySelector('#promo-original-total-price');
        const hasPromotion = this.querySelector('#has-promotion');
    
        if (quantityNotification && totalPriceElement) {
            quantityNotification.innerHTML = quantity;
            
            let moneyPrice = parseFloat(quantityNotification.getAttribute('data-price'));
            if (relatedPrice){
                moneyPrice = relatedPrice / 100;
            }
            let originalMoneyPrice = parseFloat(quantityNotification.getAttribute('data-original-price'));
            if (relatedOriginalPrice) {
                originalMoneyPrice = relatedOriginalPrice / 100;
            }
    
            // Gestione delle promozioni
            if (hasPromotion && hasPromotion.textContent === 'true') {
                const promoOriginalPriceElement = this.querySelector('#promo-original-price');
                const promoFinalPriceElement = this.querySelector('#promo-final-price');
                
                if (promoOriginalPriceElement && promoFinalPriceElement) {
                    const promoOriginalPrice = parseFloat(promoOriginalPriceElement.textContent) / 100;
                    const promoFinalPrice = parseFloat(promoFinalPriceElement.textContent) / 100;
                    
                    if (!isNaN(promoOriginalPrice) && !isNaN(promoFinalPrice)) {
                        // Calcola i prezzi totali con la promozione
                        const promoTotalPrice = promoFinalPrice * quantity;
                        const promoOriginalTotalPrice = promoOriginalPrice * quantity;
                        
                        // Mostra i prezzi promozionali
                        promoTotalPriceElement.innerHTML = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(promoTotalPrice);
                        promoOriginalTotalPriceElement.innerHTML = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(promoOriginalTotalPrice);
                        
                        // Mostra gli elementi delle promozioni e nascondi i prezzi normali
                        promoTotalPriceElement.style.display = 'inline';
                        promoOriginalTotalPriceElement.style.display = 'inline';
                        totalPriceElement.style.display = 'none';
                        originalTotalPriceElement.style.display = 'none';
                        
                        // Esci dalla funzione perché la logica della promozione è stata applicata
                        return;
                    }
                }
            }
            
            // Logica di prezzo standard (senza promozioni)
            if (!isNaN(moneyPrice)) {
                const totalPrice = moneyPrice * quantity;
                totalPriceElement.innerHTML = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(totalPrice);
                totalPriceElement.style.display = 'inline';
                
                // Assicurati che gli elementi delle promozioni siano nascosti
                if (promoTotalPriceElement) promoTotalPriceElement.style.display = 'none';
                if (promoOriginalTotalPriceElement) promoOriginalTotalPriceElement.style.display = 'none';
    
                if (!isNaN(originalMoneyPrice) && originalMoneyPrice > moneyPrice) {
                    const originalTotalPrice = originalMoneyPrice * quantity;
                    originalTotalPriceElement.innerHTML = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(originalTotalPrice);
                    originalTotalPriceElement.style.display = 'inline';
                } else {
                    originalTotalPriceElement.style.display = 'none';
                }
            }
        }
    }
    setupMutationObserver() {
        const observer = new MutationObserver((mutationsList, observer) => {
            this.chatIcon = document.getElementById('genesys-mxg-frame');
            if (this.chatIcon) {
                observer.disconnect();
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
        return null; 
    }

    open() {
        if (this.isOpen || this.isClosing) return;

        this.isOpen = true;
        this.isClosing = false;
        this.updateDesktopScrollbarWidth();
        this.elevateHeaderGroupZIndex();

        if (window.innerWidth <= 767) {
            if (!this.chatIcon) {
                this.chatIcon = document.getElementById('genesys-mxg-frame');
            }
            else  {
                this.chatIcon.style.display = 'none';
            }
            this.notification.classList.remove('closing');
            this.updateMobileTopOffset();

            if(this.isStickyCartVisible()) {
                this.notification.classList.add('active-with-sticky');
            }
            else{
                this.notification.classList.add('active');
            }
            // this.notification.style.transform = 'translateY(0)';
            //this.adjustCartNotificationPosition();
            trapFocus(this.notification);
            this.lockBodyScroll();

            document.body.removeEventListener('click', this.onBodyClick);
            document.body.addEventListener('click', this.onBodyClick);
        } else {
            this.notification.classList.add('animate', 'active', 'tw-z-50');
            this.notification.style.top = '0';
            this.updateSwiperClasses(true);
            trapFocus(this.notification);
            
            document.body.removeEventListener('click', this.onBodyClick);
            document.body.addEventListener('click', this.onBodyClick);
        }
    }

    close() {
        if (!this.isOpen || this.isClosing) return;

        this.isClosing = true;

        if (window.innerWidth <= 767) {
            if (this.chatIcon) {
                this.chatIcon.style.display = 'block';
            }
            this.notification.classList.add('closing');
            this.unlockBodyScroll();
            // this.notification.style.transform = 'translateY(100%)';
            this.isOpen = false;
            this.isClosing = false;
        } else {
            // this.notification.style.top = '';
            this.isOpen = false;
            this.isClosing = false;
        }
        this.restoreHeaderGroupZIndex();
        this.notification.classList.remove('active');
        this.notification.classList.remove('active-with-sticky');
        this.notification.classList.remove('tw-z-50');
        this.updateSwiperClasses(false);

        this.notification.removeAttribute('style');
        document.body.removeEventListener('click', this.onBodyClick);
        removeTrapFocus(this.activeElement);
    }

    updateSwiperClasses(isOpening) {
        const swiper = document.querySelector('product-recommendations.complementary-products');
        if(!swiper) return;
        const prevButton = swiper.querySelector('.swiper-button-prev');
        const nextButton = swiper.querySelector('.swiper-button-next');
        const pagination = swiper.querySelector('.swiper-pagination-bullets');
    
        const prevClass = isOpening ? '!tw-z-[-1]' : 'tw-z-100';
        const nextClass = isOpening ? '!tw-z-[-1]' : 'tw-z-100';
        const paginationClass = isOpening ? '!tw-z-[-1]' : 'tw-z-100';
    
        prevButton.classList.remove('tw-z-100', '!tw-z-[-1]');
        nextButton.classList.remove('tw-z-100', '!tw-z-[-1]');
        pagination.classList.remove('tw-z-[-1]', '!tw-z-[-1]');
    
        prevButton.classList.add(prevClass);
        nextButton.classList.add(nextClass);
        pagination.classList.add(paginationClass);
    }

    isStickyCartVisible() {
        return this.stickyAddToCart && !this.stickyAddToCart.classList.contains('tw-hidden');
    }

    adjustCartNotificationPosition() {
        const stickyVisible = this.stickyAddToCart && !this.stickyAddToCart.classList.contains('tw-hidden');

        if (window.innerWidth <= 767) {
            if (stickyVisible) {
                this.notification.style.bottom = '66px';
            } else {
                this.notification.style.bottom = '0px';
            }
        } else {
            this.notification.style.top = '0px';
        }
    }

    handleViewportChange() {
        this.updateMobileTopOffset();
        this.updateDesktopScrollbarWidth();
    }

    updateMobileTopOffset() {
        if (window.innerWidth > 767 || !this.notification) return;

        const headerGroup = document.querySelector('.shopify-section-group-header-group');
        const announcementBar =
            document.querySelector('.announcement-bar') ||
            document.querySelector('[class*="announcement"]');

        let offset = 0;
        const source = headerGroup || announcementBar;

        if (source) {
            const rect = source.getBoundingClientRect();
            if (rect.bottom > 0) {
                offset = Math.min(window.innerHeight, rect.bottom);
            }
        }

        this.notification.style.setProperty('--cart-top-offset', `${Math.round(offset)}px`);
    }

    elevateHeaderGroupZIndex() {
        const headerSection = this.closest('.shopify-section-group-header-group');
        if (headerSection) {
            this._headerSectionSavedZIndex = headerSection.style.zIndex;
            headerSection.style.zIndex = '10000';
        }
        // Push Genesys chat behind the minicart
        const genesysMessenger = document.getElementById('genesys-messenger');
        if (genesysMessenger) {
            this._genesysSavedZIndex = genesysMessenger.style.zIndex;
            genesysMessenger.style.zIndex = '0';
        }
    }

    restoreHeaderGroupZIndex() {
        const headerSection = this.closest('.shopify-section-group-header-group');
        if (headerSection) {
            headerSection.style.zIndex = this._headerSectionSavedZIndex || '';
        }
        const genesysMessenger = document.getElementById('genesys-messenger');
        if (genesysMessenger) {
            genesysMessenger.style.zIndex = this._genesysSavedZIndex || '';
        }
    }

    lockBodyScroll() {
        if (this.isBodyScrollLocked) return;

        this.lockedScrollY = window.scrollY || window.pageYOffset || 0;
        this.lockedBodyStyles = {
            position: document.body.style.position,
            top: document.body.style.top,
            left: document.body.style.left,
            right: document.body.style.right,
            width: document.body.style.width,
            overflow: document.body.style.overflow
        };

        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.lockedScrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
        this.isBodyScrollLocked = true;
    }

    unlockBodyScroll() {
        if (!this.isBodyScrollLocked) return;

        if (this.lockedBodyStyles) {
            document.body.style.position = this.lockedBodyStyles.position;
            document.body.style.top = this.lockedBodyStyles.top;
            document.body.style.left = this.lockedBodyStyles.left;
            document.body.style.right = this.lockedBodyStyles.right;
            document.body.style.width = this.lockedBodyStyles.width;
            document.body.style.overflow = this.lockedBodyStyles.overflow;
        } else {
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            document.body.style.width = '';
            document.body.style.overflow = '';
        }

        window.scrollTo(0, this.lockedScrollY);
        this.lockedBodyStyles = null;
        this.isBodyScrollLocked = false;
    }

    renderContents(parsedState) {
        this.cartItemKey = parsedState.key;
        this.getSectionsToRender().forEach((section) => {
            const sectionElement = document.getElementById(section.id);
            if (sectionElement) {
                sectionElement.innerHTML = this.getSectionInnerHTML(
                    parsedState.sections[section.id],
                    section.selector
                );
            }
        });

        if (window.innerWidth > 767 && this.header) {
            this.header.reveal();
        }

        this.open();
    }

    getSectionsToRender() {
        return [
            { id: 'cart-notification-product', selector: `[id="cart-notification-product-${this.cartItemKey}"]` },
            { id: 'cart-notification-button' },
            { id: 'cart-icon-bubble' }
        ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    handleBodyClick(evt) {
        const target = evt.target;
        if (target !== this.notification && !target.closest('cart-notification')) {
            this.close();
        }
    }

    setActiveElement(element) {
        this.activeElement = element;
    }

    isHeaderVisible() {
        return this.header && this.header.offsetHeight > 0 && this.header.getBoundingClientRect().top < window.innerHeight;
    }

    handleScroll = () => {
        const scrollTop = window.scrollY;

        if (window.innerWidth > 767) {
            if (scrollTop > 100) {
                if (scrollTop > this.lastScrollTop) {
                    this.notification.style.top = '40px';
                    if (this.header) this.header.style.transform = 'translateY(0)';
                } else {
                    this.notification.style.top = '';
                    if (this.header) this.header.style.transform = '';
                }
            } else if (!this.isHeaderVisible()) {
                this.notification.style.top = '0';
                if (this.header) this.header.style.transform = 'translateY(0)';
            } else {
                if(this.notification.classList.contains('active')){ 
                    this.adjustCartNotificationPosition();
                }
            }
        } else if (this.isOpen) {
            this.updateMobileTopOffset();
        }

        this.lastScrollTop = scrollTop;
    };
}

customElements.define('cart-notification', CartNotification);